import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "isBurkhart",
    initialState: false,
    reducers: {
        set: (state, action) => action.payload,
    },
});
